import React, { Component } from "react";
import {
  Input,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

class modal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newBusinessName: null,
    };
  }

  updateNewBusinessName = (event) => {
    if (event.target.value === "") {
      this.setState({
        [event.target.id]: null,
      });
    } else {
      this.setState({
        [event.target.id]: event.target.value,
      });
    }
  };

  render() {
    return (
      <Modal
        isOpen={this.props.activeModal === "editCustomerBusinessName"}
        toggle={() => this.props.dismissModal("editCustomerBusinessName")}
      >
        <ModalHeader>Edit Client Business Name</ModalHeader>
        <ModalBody>
          <Input
            id="newBusinessName"
            onChange={(event) => this.updateNewBusinessName(event)}
            placeHolder={this.props.name}
          />
        </ModalBody>
        <ModalFooter>
          {this.state.newBusinessName !== null ? (
            <Button
              color="success"
              onClick={() =>
                this.props.editCustomerBusinessName(
                  this.state.newBusinessName,
                  this.props._id
                )
              }
              block
            >
              Submit Changes
            </Button>
          ) : (
            <Button block disabled>
              Submit Changes
            </Button>
          )}
        </ModalFooter>
      </Modal>
    );
  }
}

export default modal;
